export default {
    'name.first': 'First name',
    'name.middle': 'Middle name',
    'name.father': 'Father / husband name',
    'name.last': 'Last name',
    'name.second_last': 'Second last name',
    'name.local': 'Name in Arabic',
    'identity.document': 'Document',
    'identity.number': 'Document number',
    'identity.issuing_country': 'Issuing country',
    'identity.expiry': 'Expiry',
    'identity.nationality': 'Nationality',
    'identity.no_document': 'No document',
    'identity.other_document': 'Other document / passport',
    'identity.usual_document': 'Use the usual document',
    'identity.missing_reason': 'Why is there no document?',
    'dob': 'Date of birth',
    'dob.hijri': 'Date of birth (Hijri)',
    'age.approximate': 'Approximate age (years)',
    'preferred_language': 'Preferred language',
    'register.title': 'Register patient',
    'register.submit': 'Register and allocate MRN',
    'register.done': 'Patient registered',
    'duplicates.title': 'Possible existing records',
    'duplicates.confirm': 'This is a different person — register anyway',
};
//# sourceMappingURL=patients.js.map